import { render, staticRenderFns } from "./PayoffScatterChart.vue?vue&type=template&id=52e8ada9&scoped=true&"
import script from "./PayoffScatterChart.vue?vue&type=script&lang=js&"
export * from "./PayoffScatterChart.vue?vue&type=script&lang=js&"
import style0 from "./PayoffScatterChart.vue?vue&type=style&index=0&id=52e8ada9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8ada9",
  null
  
)

export default component.exports